import React from "react";

function PartPlanningInformation (props) {

    const hasOemStockMin = props.partInfo.stockingMinimum && props.partInfo.stockingMinimum !== 'N/A';
    const hasMaxStockLevel = props.partInfo.maxStockLevel !== null;

    return (
        <div className="basic-info container-fluid">
            <h5 className="basic-info-title title">
                {props.pageText.partPlanningTitle}
                <i
                    className="material-icons"
                    title={props.pageText.partPlanningToolTip}
                >
                    help
                </i>
            </h5>

            <div className="basic-info-content container">
                <div className="row no-gutters">
                    <div className="col-sm-8">
                        <p className="data-header alignment">
                            {props.pageText.partPlannedAs}
                            {" "}
                            <span className="data margin-left">
                                {props.partInfo.ssTopSku}
                            </span>
                        </p>
                    </div>

                    <div className="col-sm-4">
                        <p className="data-header alignment">
                            {props.pageText.partPlanRop}
                            {" "}
                            <span className="data margin-left">
                                {props.partInfo.rop}
                            </span>
                        </p>
                    </div>
                </div>

                <div className="row no-gutters">
                    <div className="col-sm-4">
                        <p className="data-header alignment">
                            {props.pageText.totalOnOrder}
                            {" "}
                            <span className="data margin-left">
                                {props.partInfo.ssOnOrder}
                            </span>
                        </p>
                    </div>

                    <div className="col-sm-4">
                        <p className="data-header alignment">
                            {props.pageText.totalOnHand}
                            {" "}
                            <span className="data margin-left">
                                {props.partInfo.ssOnHand}
                            </span>
                        </p>
                    </div>

                    <div className="col-sm-4">
                        <p className="data-header alignment">
                            {props.pageText.stockMax}
                            {" "}
                            <span className="data margin-left">
                                {props.partInfo.stockMax}
                            </span>
                        </p>
                    </div>
                </div>

                {(hasOemStockMin || hasMaxStockLevel) &&
                    <div className="row no-gutters">
                        {hasOemStockMin &&
                            <div className="col-12 col-sm-6">
                                <p className="data-header alignment">
                                    {props.pageText.partInfoOemStockMin}
                                    {" "}
                                    <span className="data margin-left">
                                        {props.partInfo.stockingMinimum}
                                    </span>
                                    <i
                                        className="material-icons help oem-help-icon"
                                        title={props.pageText.partInfoOemStockMinToolTip}
                                    >help</i>
                                </p>
                            </div>}
                        {hasMaxStockLevel &&
                            <div className="col-12 col-sm-6">
                                <p className="data-header alignment">
                                    {props.pageText.partInfoStockLimit}
                                    {" "}
                                    <span className="data margin-left">
                                        {props.partInfo.maxStockLevel}
                                    </span>
                                    <i
                                        className="material-icons help oem-help-icon"
                                        title={props.pageText.partInfoStockLimitToolTip}
                                    >help</i>
                                </p>
                            </div>}
                    </div>}
            </div>
        </div>
    );

}

export default PartPlanningInformation;
